import React from "react";
import {Col, FormGroup, Row} from "reactstrap";
import {useSelector} from "react-redux";
import {getSimUsageDetails} from "../../../../redux/Selectors/sim.selector";
import {isEmpty} from "lodash";

function SimOverageInformation(_props, ref) {
  const simUsageDetails = useSelector(getSimUsageDetails);
  const simUsageData = simUsageDetails ? simUsageDetails : {};

  React.useImperativeHandle(ref, () => {
    return {
      state: {},
    };
  });
  const {overageLimitReached, overageLimitOverride = ""} = simUsageData;
  return (
    <div className="pl-lg-4">
      <ul>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  LIMIT REACHED:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {!isEmpty(simUsageData) && (
                    <button
                      className={`btn btn-usage-limit ${
                        overageLimitReached ? "btn-danger" : "btn-success"
                      }`}
                    />
                  )}
                  {isEmpty(simUsageData) && (
                    <label
                      className="form-control-label sim-usage-label-value"
                      htmlFor="input-name"
                    >
                      NA
                    </label>
                  )}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  LIMIT OVERRIDE:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {overageLimitOverride ? overageLimitOverride : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
      </ul>
    </div>
  );
}

export default React.forwardRef(SimOverageInformation);
